module.exports = ".mistep {\r\n    width: 100%;\r\n}\r\n\r\n\r\n.total {\r\n    float: right;\r\n}\r\n"